<template>
  <div>
    <el-row>
      <el-col :span="24">
        <el-page-header @back="onBack" title="" content="網頁常見問題">
        </el-page-header>
      </el-col>
    </el-row>
    <div class="page-box">
      <el-tabs v-model="activeName">
        <el-tab-pane label="英文" name="first"></el-tab-pane>
        <el-tab-pane label="中文" name="second"></el-tab-pane>
      </el-tabs>
      <common-problem-chinese :list="chineseList" v-show="activeName == 'second'"></common-problem-chinese>
      <common-problem-english :list="englishList" v-show="activeName == 'first'"></common-problem-english>
      <div class="page-button">
        <el-button type="info" @click="onSubmit">提交</el-button>
        <el-button type="success" @click="onBack">取消</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import commonProblemChinese from "./components/common-problem-chinese";
import commonProblemEnglish from "./components/common-problem-english";
import { getWebFaqs, addWebFaqs } from "@/api/setting";
export default {
  components: {
    commonProblemChinese,
    commonProblemEnglish,
  },
  data() {
    return {
      activeName: "first",
      englishList:[],
      chineseList:[],
    };
  },
  created() {
    this.getWebFaqChineseList();
    this.getWebFaqEnglishList();
  },
  methods: {
    onSubmit() {
      this.addWebFaqs();
    },
    addWebFaqs() {
      let from = {
        faqs: [
          ...this.englishList,
          ...this.chineseList,
        ],
      }
      addWebFaqs(from).then(() => {
        this.getWebFaqChineseList();
        this.getWebFaqEnglishList();
        this.$message({
          message: "提交成功",
          type: "success",
        });
      });
    },
   
    getWebFaqChineseList() {
      let from = {
         lang:0
      }
      getWebFaqs(from).then((v) => {
        this.chineseList = v.data;

      });
    },
    getWebFaqEnglishList() {
      let from = {
         lang:1
      }
      getWebFaqs(from).then((v) => {
        this.englishList = v.data;

      });
    },
  },
};
</script>

<style lang="scss" scoped>
.page-box {
  background-color: #fff;
  padding: 20px;
  margin-top: 20px;
}
.form-box {
  width: 400px;
}
.unit-list {
  margin-bottom: 20px;
}
.plus-outline-add {
  display: inline-block;
}
</style>